import { render, staticRenderFns } from "./ConnectionsRoute.vue?vue&type=template&id=7523a25f&scoped=true&"
import script from "./ConnectionsRoute.vue?vue&type=script&lang=js&"
export * from "./ConnectionsRoute.vue?vue&type=script&lang=js&"
import style0 from "./ConnectionsRoute.vue?vue&type=style&index=0&id=7523a25f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7523a25f",
  null
  
)

export default component.exports